<template>
  <div>
    <el-date-picker
        v-model="time"
        :picker-options="pickerOptions"
        ref="datetime"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="dateChange"
    ></el-date-picker>
  </div>
</template>

<script>
import moment from 'moment'

const DateFormat = 'YYYY-MM-DD'
const TimeFormat = 'HH:mm:ss'
const STARTTimeFormat = '00:00:00'
const Format = 'YYYY-MM-DD HH:mm'

export default {
  name: "DatePicker",
  props: {
    dateValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      time: [], 
      pickStartDate: null,
      pickerOptions: {
        disabledDate: time => {
          return moment().subtract(0, "days") < time.getTime();
        },
        onPick: ({ minDate, maxDate }) => {
          if (!(minDate && maxDate)) {
            return
          }
          const picker = this.$refs.datetime.picker
          const { minTimePicker, maxTimePicker } = picker.$refs
          const today = new Date();
          const pickStartDate = moment(minDate).format(DateFormat) 
          const pickEndDate = moment(maxDate).format(DateFormat) 
          const startDate = moment(today).format(DateFormat)
          const maxEndTime = moment(today).format(TimeFormat) 
          
          if (pickStartDate === startDate) {
            minTimePicker.selectableRange = [
              [new Date(`${startDate} ${STARTTimeFormat}`), new Date(`${startDate} ${maxEndTime}`)]
            ]
          } else {
            minTimePicker.selectableRange = []
          }
          if (pickEndDate === startDate) {
            maxTimePicker.selectableRange = [
               [new Date(`${startDate} ${STARTTimeFormat}`), new Date(`${startDate} ${maxEndTime}`)]
            ]
          } else {
            maxTimePicker.selectableRange = []
          }
        }
      }
    }
  },
  watch: {
    dateValue: {
      handler: function (val) {
        this.time = val
      }
    }
  },
  methods: {
    dateChange(e) {
      let dateRange = e;
      if (e && e.length > 1) {
        const start = new Date(dateRange[0]).getTime();
        const end = new Date(dateRange[1]).getTime();
        const offset = end - start;
        if (offset > 1000 * 60 * 60 * 24 * 2) {
          this.$message.warning('开始时间与结束时间跨度最大不可超过48小时');
          this.time = null;
        }  else {
          this.time = dateRange;
        }
        this.$emit('dateChange', this.time);
      } else {
        this.$emit('dateChange', e);
      }
    }
     
  }
}
</script>